export default "__VITE_ASSET__fSrX6bYL__"